export default __webpack_public_path__ + "1f129497cd349562c2665711e2246b3f.ttf";